import { StateUser } from '@/interfaces/state.usuario.interfaces'

const getters = {
  token (state: StateUser) {
    return state.token
  }
}

export default getters
